exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.checked-icon[data-v-5b239e98] {color: #28a745;}\n.unchecked-icon[data-v-5b239e98] {color: #dc3545;}\n", ""]);

